import { modalityTypesLabels } from '@/constants/catalog/course';
import { type DurationTypes, ModalityTypes } from '@/models/catalog/course';
import { formatDuration } from '@/utils/masks/time';

export const formatDurationWithModality = (
  duration?: number,
  durationType?: DurationTypes,
  modality?: ModalityTypes
): string => {
  const formattedModality = modality ? modalityTypesLabels[modality] : '';

  if (!duration || !durationType) return formattedModality;

  const formattedDuration = formatDuration(durationType, duration);
  return formattedModality
    ? `${formattedDuration} • ${formattedModality}`
    : formattedDuration;
};
